import { ReactNode } from 'react'

import styles from '../search.module.scss'
import Icon, { IconProps } from '@/components/styleguide/Icon'
import { Size } from '@/types/system'

type FilterCategoryProps = {
  header?: string
  icon?: IconProps['name']
  children: ReactNode
  hasBorderBottom?: boolean
}

export const FilterCategory = ({
  header,
  icon,
  children,
  hasBorderBottom,
}: FilterCategoryProps) => {
  return (
    <div className={`${styles.category} ${hasBorderBottom ? styles['with-border'] : ''}`}>
      {header && (
        <div className={styles.header}>
          <div className={styles.text}>
            <h3 className={styles.title}>
              {icon && (
                <Icon
                  name={icon}
                  customClass={styles.icon}
                  size={Size.Large}
                />
              )}
              {header}
            </h3>
          </div>
        </div>
      )}
      {children}
    </div>
  )
}
